import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20a%20pristine%20tropical%20beach%20with%20crystal%20clear%20turquoise%20water%20meeting%20soft%20white%20sand%2C%20gentle%20waves%20lapping%20the%20shore%2C%20warm%20golden%20sunlight%2C%20scattered%20palm%20trees%20in%20the%20distance%2C%20clean%20minimalist%20paradise%20aesthetic%2C%20bright%20uplifting%20atmosphere%2C%20no%20people%2C%20editorial%20travel%20photography&width=1600&height=900&seq=hero-beach-main&orientation=landscape"
        alt="Pristine beach with clear turquoise water"
        className="absolute inset-0 w-full h-full object-cover"
        title="Clear Beaches — Support Beach Cleanup Today"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-teal-900/35"></div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
            {t('hero.title1')}
            <br />
            <span className="italic font-normal text-background-50/90">
              {t('hero.title2')}
            </span>
          </h2>
          <p className="mt-5 md:mt-6 text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed font-light">
            {t('hero.subtitle')}
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/donate"
              className="px-8 py-3 md:px-10 md:py-3.5 text-sm md:text-base font-semibold bg-background-50 text-foreground-950 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta')}
            </Link>
            <Link
              to="/how-it-works"
              className="px-8 py-3 md:px-10 md:py-3.5 text-sm md:text-base font-medium text-background-50 border border-background-50/30 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('hero.secondary')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}